import { Input, InputGroup, InputRightElement, Spinner, Icon } from '@/ui';
import { GradientCrown } from '@/ui/Icon/GradientCrown';

type EditableInputProps = {
  slug: string;
  error: boolean;
  isEditing: boolean;
  debouncedIsPending: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  onFocus: () => void;
};

export const EditableInput = ({
  slug,
  error,
  isEditing,
  debouncedIsPending,
  inputRef,
  onChange,
  onBlur,
  onFocus,
}: EditableInputProps) => {
  const getInputIcon = () => {
    if (isEditing && debouncedIsPending) {
      return <Spinner size="sm" />;
    }

    if (isEditing && !debouncedIsPending) {
      return (
        <Icon
          color={error ? 'red.500' : 'green.500'}
          fontSize="20px"
          icon={error ? 'X' : 'Checkmark'}
        />
      );
    }
    return <GradientCrown mr="1.5" />;
  };

  return (
    <InputGroup>
      <Input
        bg="customgray.bglight"
        ref={inputRef}
        value={slug}
        _focus={{
          borderColor: !isEditing
            ? 'brand.500'
            : !error
              ? 'green.500'
              : 'brand.500',
        }}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
      />
      <InputRightElement>{getInputIcon()}</InputRightElement>
    </InputGroup>
  );
};
